import { useEffect, useMemo, useRef } from 'react';
import { createAutosaver } from './autosaver';
// Debounced background save for a wizard step. Leaving the step (Back, a stepper click, Review → Edit) flushes the
// pending payload instead of dropping it; Continue calls cancel() first because it saves explicitly.
export function useAutosave(save, step, delay = 2000) {
  const saveRef = useRef(save); saveRef.current = save;
  const auto = useMemo(() => createAutosaver((n, payload) => saveRef.current(n, payload), step, delay), [step, delay]);
  useEffect(() => () => auto.flush(), [auto]);
  return auto;
}
